export class callService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }

    cancelManualCallReprogramed() {
        const action = "cancelManualCallReprogramed";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action
            }
            this.SingletonWebSocket.send(message);
        }
    }

    GetCampaignsRelated() {
        const action = "GetCampaignsRelated";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "OpenWindow",
                window: "ManualCall",
            }
            this.SingletonWebSocket.send(message);
        }
    }

    makeManualCall(phoneNum, campID, clientName, callKey) {
        const action = "makeManualCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "ManualCall",
                camId: campID,
                callKey: callKey,
                clientName: clientName,
                phoneNumber: phoneNum,
            }
            this.SingletonWebSocket.send(message);
        }
    }

    HangUpCall() {
        const action = "HangUp";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "CallAction",
                callAction: action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    hangUpAndLeaveMessage() {
        const action = "hangUpAndLeaveMessage";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "CallAction",
                callAction: action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    HangUpManualDial() {
        const action = "HangUpManualDial";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = { client: "integration", action }
            this.SingletonWebSocket.send(message);
        }
    }

    UpdateDataCall(callOutID, data1, data2, data3, data4, data5) {
        const action = "UpdateDataCall";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                callOutID,
                client: "integration",
                data: [data1, data2, data3, data4, data5],
                action: "CallAction",
                callAction: action
            }
            this.SingletonWebSocket.send(message);
        }
    }

    getTransfersOptions() {
        const action = "getTransfersOptions";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "GetTransferData"
            }
            this.SingletonWebSocket.send(message);
        }
    }
    transferCallToACD(transferCallToACDID) {
        const action = "transferCallToACD";
        const dataCall = this.SingletonSharedData.getDataCall();
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const data = {
                acdID: parseInt(transferCallToACDID),
                array: "",
                callKey: dataCall ? dataCall.CalKey : "",
                camId: dataCall ? dataCall.Id : "",
                dnis: dataCall ? dataCall.DNIS : "",
                extId: 0,
                name: "",
                reference: "dial",
                sPhone: dataCall ? dataCall.Phone : "",
                typeTransfer: 2
            };
            const message = {
                client: "integration",
                data: data,
                action
            };
            this.SingletonWebSocket.send(message);
        }
    }
    transferCallToAgent(transferCallToAgentID) {
        const action = "transferCallToAgent";
        const dataCall = this.SingletonSharedData.getDataCall();
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const data = {
                acdID: 1,
                datos: "",
                callKey: dataCall ? dataCall.CalKey : "",
                camId: dataCall ? dataCall.Id : "",
                dnis: dataCall ? dataCall.DNIS : "",
                extId: parseInt(transferCallToAgentID),
                name: "",
                reference: "dial",
                sPhone: dataCall ? dataCall.Phone : "",
                typeTransfer: 1
            }
            const message = { client: "integration", data, action }
            this.SingletonWebSocket.send(message);
        }
    }
    transferCallToPhoneNumber(transferCallToPhone) {
        const action = "transferCallToPhoneNumber";
        const dataCall = this.SingletonSharedData.getDataCall();
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const data = {
                acdID: 1,
                datos: "",
                callKey: dataCall ? dataCall.CalKey : "",
                camId: dataCall ? dataCall.Id : "",
                dnis: dataCall ? dataCall.DNIS : "",
                extId: 0,
                name: "",
                reference: "dial",
                sPhone: transferCallToPhone,
                typeTransfer: 0
            }
            const message = { client: "integration", data: data, action: "transferCallToPhoneNumber" }
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/callService.js